module.exports = __webpack_public_path__ + "static/img/电话-4.6dcf1cd4.png";